import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaStar, FaClock, FaPhone, FaWhatsapp } from 'react-icons/fa';

const tomorrow = (() => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toLocaleDateString(undefined, { weekday: 'long', month: 'short', day: 'numeric' });
})();


// Mock data – replace with API later
const CHEFS = [
  {
    id: 1,
    name: 'Asha’s Kitchen',
    location: 'Indiranagar, BLR',
    rating: 4.7,
    phone: '+91 90000 11111',
    whatsapp: '+919000011111',
    cuisines: ['South Indian', 'Healthy'],
    hero: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?q=80&w=1600&auto=format&fit=crop',
    menu: {
      breakfast: [
        { name: 'Idli & Sambar', price: 80, desc: '2 idlis, sambar, chutney' },
        { name: 'Rava Upma', price: 70 },
      ],
      lunch: [
        { name: 'Veg Meals', price: 160, desc: '2 sabzi, dal, rice, chapati, salad' },
        { name: 'Curd Rice', price: 120 },
      ],
      dinner: [
        { name: 'Chapati & Dal', price: 120 },
        { name: 'Lemon Rice', price: 100 },
      ],
    },
  },
  {
    id: 2,
    name: 'Rani’s Home Food',
    location: 'HSR Layout, BLR',
    rating: 4.5,
    phone: '+91 93333 22222',
    whatsapp: '+919333322222',
    cuisines: ['North Indian', 'Daily Meals'],
    hero: 'https://images.unsplash.com/photo-1543353071-087092ec393e?q=80&w=1600&auto=format&fit=crop',
    menu: {
      breakfast: [
        { name: 'Poha', price: 70 },
        { name: 'Paratha & Curd', price: 100 },
      ],
      lunch: [
        { name: 'Thali', price: 180, desc: 'Paneer sabzi, dal, rice, roti, salad' },
        { name: 'Rajma Chawal', price: 150 },
      ],
      dinner: [
        { name: 'Jeera Rice & Dal Fry', price: 160 },
        { name: 'Khichdi', price: 130 },
      ],
    },
  },
];

function Pill({ children }) {
  return <span className="btn" style={{ background: '#f3f4f6', color: '#374151', borderRadius: 999, padding: '6px 10px' }}>{children}</span>;
}

const SectionTabs = ({ value, onChange }) => {
  const items = ['breakfast', 'lunch', 'dinner'];
  return (
    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
      {items.map((k) => (
        <button
          key={k}
          onClick={() => onChange(k)}
          className={`btn ${value === k ? 'btn-cta' : 'btn-settings'}`}
          style={{ padding: '8px 12px', borderRadius: 999, textTransform: 'capitalize' }}
        >
          {k}
        </button>
      ))}
    </div>
  );
};

const ChefCard = ({ chef, tab }) => {
  const whatsAppHref = useMemo(() => {
    const text = encodeURIComponent(`Pre-order for ${tomorrow} from ${chef.name}`);
    return `https://wa.me/${chef.whatsapp.replace(/[^\d]/g, '')}?text=${text}`;
  }, [chef]);

  const menu = chef.menu[tab] || [];

  return (
    <motion.div whileHover={{ y: -4 }} transition={{ duration: 0.2 }} className="card" style={{ overflow: 'hidden', padding: 0 }}>
      <div style={{ position: 'relative', height: 160, overflow: 'hidden' }}>
        <img src={chef.hero} alt={chef.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
      </div>
      <div style={{ padding: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
          <div>
            <h3 style={{ margin: 0 }}>{chef.name}</h3>
            <div style={{ display: 'flex', alignItems: 'center', gap: 6, color: '#6b7280', fontSize: 14 }}>
              <FaMapMarkerAlt /> {chef.location} • <FaStar style={{ color: '#f59e0b' }} /> {chef.rating}
            </div>
            <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
              {chef.cuisines.map((c) => <Pill key={c}>{c}</Pill>)}
            </div>
          </div>
          <div style={{ textAlign: 'right' }}>
            <div style={{ color: '#6b7280', fontSize: 12, marginBottom: 6 }}>
              Pre-order for {tomorrow}
            </div>
            <a href={`tel:${chef.phone}`} className="btn btn-settings" style={{ borderRadius: 10, padding: '8px 12px', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <FaPhone /> Call
            </a>
            <a href={whatsAppHref} target="_blank" rel="noreferrer" className="btn btn-cta" style={{ borderRadius: 10, padding: '8px 12px', marginLeft: 8, display: 'inline-flex', alignItems: 'center', gap: 8 }}>
              <FaWhatsapp /> WhatsApp
            </a>
          </div>
        </div>

        <div style={{ marginTop: 16 }}>
          {menu.length > 0 ? (
            <div style={{ display: 'grid', gap: 10 }}>
              {menu.map((item, i) => (
                <div key={i} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                  <div>
                    <div style={{ fontWeight: 700 }}>{item.name}</div>
                    {item.desc && <div style={{ color: '#6b7280', fontSize: 14 }}>{item.desc}</div>}
                  </div>
                  <div style={{ fontWeight: 800 }}>₹{item.price}</div>
                </div>


              ))}
            </div>
          ) : (
            <div style={{ color: '#6b7280' }}>No items listed for {tab}</div>
          )}
        </div>
      </div>
    </motion.div>
  );
};


export default function HomeChefs() {
  const [tab, setTab] = useState('breakfast');

  return (
    <div className="page">
      <div className="container">
        <div className="page-header">
          <h1>Home Chefs</h1>
          <p>Discover home makers you can pre-order from. Menus shown for the next day: {tomorrow}.</p>
        </div>

        <div className="card" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#6b7280' }}>
            <FaClock /> Pre-order windows vary by chef. Please WhatsApp to confirm.
          </div>
          <SectionTabs value={tab} onChange={setTab} />
        </div>

        <div style={{ marginTop: 16, display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 16 }}>
          {CHEFS.map((c) => (
            <ChefCard key={c.id} chef={c} tab={tab} />
          ))}
        </div>

      </div>
    </div>
  );
}

